var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"after-read":_vm.afterRead,"deletable":!_vm.readonly,"max-count":_vm.readonly ? 0 : undefined,"accept":_vm.accept,"multiple":_vm.multiple},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})
}
var staticRenderFns = []

export { render, staticRenderFns }